"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EXCEEDED_MESSAGE = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var prop_types_1 = __importDefault(require("prop-types"));

var index_1 = require("../../index");

require("./index.css");

exports.EXCEEDED_MESSAGE = ' - Suggested character count exceeded';

var WordCountComponent = function (_a) {
  var charCount = _a.charCount,
      allowedCount = _a.allowedCount;
  var countExceeded = charCount > allowedCount;
  return (0, jsx_runtime_1.jsxs)("div", __assign({
    className: "word-count"
  }, {
    children: [countExceeded && (0, jsx_runtime_1.jsx)(index_1.Icon, {
      name: "information",
      className: "fill icon-yellow",
      width: 16
    }, void 0), charCount, " /", allowedCount, countExceeded && (0, jsx_runtime_1.jsx)("span", __assign({
      className: "word-count__msg"
    }, {
      children: exports.EXCEEDED_MESSAGE
    }), void 0)]
  }), void 0);
};

WordCountComponent.propTypes = {
  charCount: prop_types_1.default.number.isRequired,
  allowedCount: prop_types_1.default.number
};
WordCountComponent.defaultProps = {
  allowedCount: 500
};
exports.default = WordCountComponent;